<template>
  <div class="oldWarpper">
    <keep-alive exclude="TPage">
      <router-view />
    </keep-alive>
  </div>

</template>

<script>
  export default {
    name: 'oldIndex'
  }

</script>

<style>
.oldWarpper {
  max-width: 750px;
  margin: 0 auto;
  position: relative;
}
/* 生产环境 */
.production-color {
  color: #3291f4;
  font-weight: 700;
  font-size: 14px;
}
/* 仿真环境 */
.emulator-color {  
  color: #f27c83;
  font-weight: 700;
  font-size: 14px;
}
/* 其他环境 */
.other-color {
  color: #f00;
  font-weight: 700;
  font-size: 14px;
}
</style>
